export default __webpack_public_path__ + "static/media/race-bg.976d6d69.png";